module.exports = __webpack_public_path__ + "react04.636afc88babb15fafaff2e1f9afc04c2.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/react04.svg
// module id = 865
// module chunks = 0